import React from "react";

const data = [
  {
    title: "Web Application Development",
    id: 1
  },
  {
    title: "Enterprise Software Solutions",
    id: 2
  },
  {
    title: "Cloud-based Applications",
    id: 3
  },
  {
    title: "Website Design and Development",
    id: 4
  },
  {
    title: "E-commerce Solutions",
    id: 5
  },
  {
    title: "Content Management Systems (CMS)",
    id: 6
  },
  {
    title: "Responsive Web Design",
    id: 7
  },
  {
    title: "Technology Strategy and Planning",
    id: 8
  },
  {
    title: "IT Infrastructure Assessment",
    id: 9
  },
  {
    title: "Security and Compliance Consulting",
    id: 10
  },
  {
    title: "Digital Transformation Advisory",
    id: 11
  },
  {
    title: "Technology Workshops",
    id: 12
  },
  {
    title: "Customized Training Sessions",
    id: 13
  },
  {
    title: "Skill Development Programs",
    id: 14
  },
];

export default function ServiceCard() {
  return (
    <div className="row justify-content-center">
      {data.map((ele) => {
        return (
          <div className="col-lg-4 col-sm-6" key={ele.id}>
            <div className="service-item-seven">
              <h3>{ele.title}</h3>
            </div>
          </div>
        );
      })}
    </div>
  );
}
